import React, { Component } from "react";
import axios from "axios";

class UserprofileForm extends Component {
  state = {
    dataprofiles: [],
    profiles: [],
    isChecked: {},
  };

  componentDidMount() {
    this.dataprofiles();
  }

  handleInputCheckbox = (e, profile) => {
    const checked = e.target.checked;

    this.setState(
      (prevState) => {
        const isChecked = {
          ...prevState.isChecked,
          [profile.id]: checked,
        };

        const profiles = checked
          ? [...new Set([...prevState.profiles, profile.id])]
          : prevState.profiles.filter((id) => id !== profile.id);

        return { isChecked, profiles };
      },
      () => {
        this.props.profiles(this.state.profiles);
      }
    );
  };

  async dataprofiles() {
    const request = await axios.get("profiles");

    if (request.status === 200) {
      this.setState({
        dataprofiles: request.data,
      });
    }
  }

  render() {
    const userprofiles = this.state.dataprofiles
      .filter((profile) => profile.model === this.props.model)
      .map((profile) => (
        <label
          htmlFor={`profile-${profile.id}`}
          className="ev-choice"
          key={profile.id}
        >
          <input
            id={`profile-${profile.id}`}
            type="checkbox"
            checked={!!this.state.isChecked[profile.id]}
            onChange={(e) => this.handleInputCheckbox(e, profile)}
          />

          <span>{profile.profile}</span>
        </label>
      ));

    return (
      <div className="ev-choice-group">
        {userprofiles}
      </div>
    );
  }
}

export default UserprofileForm;
